import { generateClient } from "aws-amplify/api";

import { fetchAuthSession } from "aws-amplify/auth";

import Store from "@/store";
import i18n from "@/i18n";
import { isMutation, isSchemaMismatch, recoverFromStaleBundle } from "@/lib/staleBundle";

const client = generateClient();

export const runQuery = async (query, variables, { silent = false } = {}) => {
  try {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();

    if (!idToken) {
      console.error("No ID token found in session");
      throw new Error("Authentication failed: Missing ID Token");
    }

    const result = await client.graphql({
      query,
      variables,
      authToken: idToken,
    });

    return result.data;
  } catch (error) {
    if (silent) {
      console.log("silent error:");
      console.error(error);
      return;
    }

    const errors = error.errors || error.data?.errors || (error.message ? [{ message: error.message }] : []);
    const message = errors && errors.length ? errors[0].message : i18n.global.t("error.unknown");
    if (isSchemaMismatch(error)) {
      if (!isMutation(query) && recoverFromStaleBundle()) {
        return;
      }
      await Store.dispatch("showNotification", {
        title: i18n.global.t("error.outdated"),
        text: i18n.global.t("error.outdatedDescription"),
        type: "error",
      });
      return;
    }

    // TODO find a better way to handle all error translations
    if (error && error.errors && error.errors[0].errorType == "PermissionError") {
      if (error.errors[0].message == "Insufficient permissions provided (INSUFFICIENT_ROLES)") {
        await Store.dispatch("showNotification", {
          title: i18n.global.t("error.permissions"),
          text: i18n.global.t("error.permissionsDescription"),
          type: "error",
        });
        return;
      }
    }

    await Store.dispatch("showNotification", {
      title: i18n.global.t("error.unknown"),
      text: message,
      type: "error",
    });
  }
};
